"use client";

import { Navigation } from "ui/Navigation";
import { Footer } from "ui/Footer";
import { useCheckProfile } from "@/hooks/useCheckCRMProfile";
import { GoogleTagManager } from "@next/third-parties/google";
import useConfig from "@/hooks/useConfig";

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element {
  const profileCheck = useCheckProfile();
  const config = useConfig();

  if (profileCheck.loading) return <></>;

  return (
    <>
      {config.gtmID && (
        <GoogleTagManager gtmId={config.gtmID} />
      )}
      <Navigation>
        <div className="bg-background-light mobile:bg-white">{children}</div>
        <Footer />
      </Navigation>
    </>
  );
}
